/**
 * P2025 Colour Section Carousel
 * Initializes Embla carousel for colour section on mobile when items > 6
 */
(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 768;
  const MIN_ITEMS_FOR_CAROUSEL = 6;

  class ColourCarousel {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector('.p2025-colour-section__carousel');
      this.grid = section.querySelector('.p2025-colour-section__grid');
      this.viewport = section.querySelector('.p2025-colour-section__carousel-viewport');
      this.container = section.querySelector('.p2025-colour-section__carousel-container');
      this.itemCount = parseInt(section.dataset.colourItems) || 0;
      this.embla = null;
      this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      
      if (!this.carousel || !this.viewport || !this.container) return;
      
      this.init();
    }

    init() {
      this.handleResize();
      window.addEventListener('resize', () => this.handleResize());
    }

    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      
      // Only show carousel on mobile when items > 6
      const shouldShowCarousel = this.isMobile && this.itemCount > MIN_ITEMS_FOR_CAROUSEL;
      
      if (shouldShowCarousel && !this.embla) {
        this.initCarousel();
      } else if (!shouldShowCarousel && this.embla) {
        this.destroyCarousel();
      }
      
      // Show/hide grid and carousel based on breakpoint
      if (this.grid) {
        this.grid.style.display = shouldShowCarousel ? 'none' : 'grid';
      }
      if (this.carousel) {
        this.carousel.style.display = shouldShowCarousel ? 'block' : 'none';
      }
    }

    initCarousel() {
      if (!window.EmblaCarousel) {
        console.warn('EmblaCarousel not loaded');
        return;
      }

      if (this.embla) {
        this.destroyCarousel();
      }

      this.embla = EmblaCarousel(this.viewport, {
        loop: false,
        dragFree: true,
        containScroll: 'keepSnaps',
        slidesToScroll: 1
      });

      // Recalculate on resize
      this.embla.on('resize', () => {
        this.embla.reInit();
      });
    }

    destroyCarousel() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
    }
  }

  // Initialize all colour sections on DOM ready
  function initColourCarousels() {
    document.querySelectorAll('.p2025-colour-section[data-colour-items]').forEach(section => {
      new ColourCarousel(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColourCarousels);
  } else {
    initColourCarousels();
  }

  // Re-initialize if new sections are added dynamically
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('.p2025-colour-section[data-colour-items]:not([data-carousel-initialized])').forEach(section => {
        section.setAttribute('data-carousel-initialized', 'true');
        new ColourCarousel(section);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

